import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frRaces from './locales/fr/races.json';
import frBets from './locales/fr/bets.json';
import frProfile from './locales/fr/profile.json';
import frErrors from './locales/fr/errors.json';
import frHome from './locales/fr/home.json';
import frScoring from './locales/fr/scoring.json';
import frLegal from './locales/fr/legal.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enRaces from './locales/en/races.json';
import enBets from './locales/en/bets.json';
import enProfile from './locales/en/profile.json';
import enErrors from './locales/en/errors.json';
import enHome from './locales/en/home.json';
import enScoring from './locales/en/scoring.json';
import enLegal from './locales/en/legal.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: {
                common: frCommon,
                auth: frAuth,
                races: frRaces,
                bets: frBets,
                profile: frProfile,
                errors: frErrors,
                home: frHome,
                scoring: frScoring,
                legal: frLegal,
            },
            en: {
                common: enCommon,
                auth: enAuth,
                races: enRaces,
                bets: enBets,
                profile: enProfile,
                errors: enErrors,
                home: enHome,
                scoring: enScoring,
                legal: enLegal,
            },
        },
        fallbackLng: 'fr',
        defaultNS: 'common',
        ns: ['common', 'auth', 'races', 'bets', 'profile', 'errors', 'home', 'scoring', 'legal'],
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'i18n_language',
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
